<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="flex-grow-1 px-2 email-custom-card elevation-3">
    <div class="pa-2">
      <div class="subject pb-2">{{ $t('subject', { subject: data.subject }) }}</div>
      <div v-if="data.from">
        <strong v-once class="label">{{ $t('from') }}</strong> {{ data.from }}
      </div>
      <div>
        <strong v-once class="label">{{ $t('date') }}</strong> {{ date }}
      </div>
      <div>
        <strong v-once class="label">{{ $t('to') }}</strong> {{ data.to }}
      </div>
      <div v-if="data.cc">CC: {{ data.cc }}</div>
      <div v-if="data.bcc">BCC: {{ bccEmails }}</div>
    </div>
    <EcsEmailAttachments
      v-if="data.attachments.length"
      class="px-2"
      :file-name="fileName"
      :content-type="contentType"
      :attachments="data.attachments"
      @onAttachmentDownload="onAttachmentDownload"
    />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="pa-2 email-body" v-html="parsedBody"></div>
  </div>
</template>

<script>
import EcsEmailAttachments from '@/components/ecs-email/ecs-email-attachments/EcsEmailAttachments';
import EcsTimeFormatter from '@/mixins/ecs-time-formatter/EcsTimeFormatter';

export default {
  name: 'EcsEmailContent',

  components: { EcsEmailAttachments },

  mixins: [EcsTimeFormatter],

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    fileName: {
      type: String,
      default: 'fileName'
    },
    contentType: {
      type: String,
      default: 'contentType'
    }
  },

  computed: {
    date() {
      return this.formattedDateTime(this.data.creationTime);
    },
    bccEmails() {
      let bccEmails = this.data.bcc;
      if (this.data.requiredBcc !== null && this.data.requiredBcc !== '') {
        bccEmails = `${this.data.requiredBcc}; ${this.data.bcc}`;
      }
      return bccEmails;
    },
    parsedBody() {
      return this.data.body.replaceAll(/src="cid:(.*)"/gi, 'src=""');
    }
  },

  methods: {
    onAttachmentDownload(file) {
      this.$emit('onAttachmentDownload', file);
    }
  }
};
</script>

<style scoped>
.label {
  font-size: 16px;
}
.subject {
  font-weight: bold;
  font-size: 18px;
}
.email-body {
  word-wrap: break-word;
}
</style>
